import React from "react";

export function InstancesEmptyState(): JSX.Element {
  return <p>Code is not yet instantiated</p>;
}
